<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                    <h3>教材信息</h3>
                    <p></p>
                </div>
                <div class="info-main">
                    <div class="input-box">
                        <p>学年：</p>
                        <a-date-picker
                            class="input"
                            mode="year"
                            format='YYYY'
                            v-model="year" 
                            :open='yearShowOne' 
                            @openChange="openChangeOne"
                            @panelChange="panelChangeOne">
                            <a-input  v-model="bookInfo.schoolYear" />
                        </a-date-picker>
                    </div>
                    <div class="input-box">
                        <p>学期：</p>
                        <a-select class="input" allowClear v-model="bookInfo.semester" >
                            <!-- For years before 2025, keep all options -->
                            <template v-if="year < '2025'">
                                <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                                <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                                <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                                <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
                            </template>
                            <!-- For 2025 and later, only show two semesters -->
                            <template v-else>
                                <a-select-option :value="year+'A'">秋季学期</a-select-option>
                                <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                            </template>
                        </a-select> 
                    </div>  
                    <div class="input-box">
                        <p><span>*</span>教材名称：</p>
                        <a-input class="input" v-model="bookInfo.name" :disabled="type=='look'||type=='examine'" />
                    </div>
                    <div class="input-box">
                        <p>教材种类：</p>
                        <a-select class="input" allowClear v-model="bookInfo.bookType" :disabled="type=='look'||type=='examine'">
                            <a-select-option  value="纸质">纸质</a-select-option>
                            <a-select-option  value="电子">电子</a-select-option>
                            <a-select-option  value="课件">课件</a-select-option>
                        </a-select> 
                    </div>
                    <div class="input-box">
                        <p><span>*</span>作者：</p>
                        <a-input class="input" v-model="bookInfo.author" :disabled="type=='look'||type=='examine'" />
                    </div>
                    <div class="input-box">
                        <p><span>*</span>出版社：</p>
                        <a-input class="input" v-model="bookInfo.press" :disabled="type=='look'||type=='examine'" />
                    </div>
                    <div class="input-box">
                        <p>出版年月：</p>
                        <a-month-picker class="input" v-model="bookInfo.publishDate" @change="(date, dateString)=>{info.publishDate=dateString}" :disabled="type=='look'||type=='examine'"/>
                    </div>
                    <div class="input-box">
                        <p>ISBN：</p>
                        <a-input class="input" v-model="bookInfo.isbn" :disabled="type=='look'||type=='examine'" />
                    </div>
                    <div class="input-box">
                        <p>版次：</p>
                        <a-input class="input" v-model="bookInfo.edition" :disabled="type=='look'||type=='examine'" />
                    </div>
                    <div class="input-box">
                        <p>是否马工程：</p>
                        <a-select 
                            class="input" 
                            allowClear 
                            v-model="bookInfo.isMarx" 
                            :disabled="type=='look'||type=='examine'" >
                            <a-select-option :value="true">是</a-select-option>
                            <a-select-option :value="false">否</a-select-option>
                        </a-select>
                    </div>
                    <div class="input-box">
                        <p>是否国家级规划教材：</p>
                        <a-select 
                            class="input" 
                            allowClear 
                            v-model="bookInfo.isStateLevel" 
                            :disabled="type=='look'||type=='examine'" >
                            <a-select-option :value="true">是</a-select-option>
                            <a-select-option :value="false">否</a-select-option>
                        </a-select>
                    </div>
                    <div class="input-box">
                        <p>是否全英语：</p>
                        <a-select 
                            class="input" 
                            allowClear 
                            v-model="bookInfo.isAllEnglish" 
                            :disabled="type=='look'||type=='examine'" >
                            <a-select-option :value="true">是</a-select-option>
                            <a-select-option :value="false">否</a-select-option>
                        </a-select>
                    </div>
                </div>
            </div>
            <div>
                <div class="info-title">
                    <h3>附件</h3>
                    <p></p>
                </div>
                <div class="upload-info-box">
                    <div class="upload-box">
                        <a-upload-dragger
                            class="upload-box"
                            name="file"
                            list-type="picture-card"
                            :multiple="true"
                            :action="$store.state.axiosUrl+'/api-f/files'"
                            :headers="headers"
                            @change="coverFileChange"
                            :file-list="coverFileList"
                        >
                            <p class="ant-upload-drag-icon">
                                <a-icon type="inbox" />
                            </p>
                            <p class="ant-upload-text">点击或拖拽教材封面文件上传</p>
                            <p class="ant-upload-hint">支持单次或批量上传</p>
                        </a-upload-dragger>
                    </div>
                    <div class="upload-box">
                        <a-upload-dragger
                            class="upload-box"
                            name="file"
                            list-type="picture-card"
                            :multiple="true"
                            :action="$store.state.axiosUrl+'/api-f/files'"
                            :headers="headers"
                            @change="syllabusFileChange"
                            :file-list="syllabusFileList"
                        >
                            <p class="ant-upload-drag-icon">
                                <a-icon type="inbox" />
                            </p>
                            <p class="ant-upload-text">点击或拖拽课程大纲文件上传</p>
                            <p class="ant-upload-hint">支持单次或批量上传</p>
                        </a-upload-dragger>
                    </div>
                </div>
            </div>
            <div v-if="type!='edit' && type !='add'">
                <div class="info-title">
                    <h3>审批意见</h3>
                    <p></p>
                </div>
                <div class="info-main">      
                    <div class="input-box input-box-big">
                        <p>意见：</p>
                        <a-textarea class="input" v-model="bookApproveInfo.approvalComments" :rows="2"/>
                    </div>
                </div>
            </div>
             <div class="btn-box">
                <a-button key="back" @click="$router.go(-1)">
                取消
                </a-button>
                <a-button key="submit" type="primary" v-if="type == 'add' || type == 'edit'" :loading="loading" @click="handleOk('commit')">
                确定
                </a-button>
                <a-button key="submit" type="primary" v-if="type == 'approve'" :loading="loading" @click="handleOk('reject')">
                驳回
                </a-button>
                <a-button key="submit" type="primary" v-if="type == 'approve'" :loading="loading" @click="handleOk('approved')">
                通过
                </a-button>
            </div>
    </div>
</template>
<script>
    import { list } from '@/baseAPI/undergraduate/culture/courseMould'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    import { getSchoolYear,getSemester } from '@/baseAPI/util'
    import { bookInfoCourse,addBook,bookInfo,bookEdit,bookApprove } from '@/baseAPI/undergraduate/culture/syllabusAndBooks'
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                title:'',
                bookApproveInfo:{
                    id: null,
                    approvalStatus: null,
                    approvalComments: null
                },
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                searchForm:{
                    courseNo:'',
                    languageName:'',
                    semester:''
                },
                bookInfo:{
                    id:null,
                    courseProgramId:null,
                    name:null,
                    author:null,
                    press:null,
                    publishDate:null,
                    isbn:null,
                    edition:null,
                    isMarx:null,
                    isStateLevel:null,
                    isAllEnglish:null,
                    coverFile:null,
                    schoolYear:null,
                    semester:null,
                    courseNo:null,
                    languageName:null,
                    coverFile:null,
                    files:null,
                    approvalStatus:null

                },
                kcArr:[],
                jsArr:[],
                opinion:'',
                visible: false,
                year:'',
                yearShowOne:false,
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                type:'',
                coverFileList:[],
                syllabusFileList:[],
                coverFile:[],
                files:[],
                permissions:[],
                courseId:''
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            list().then(res=>{
                this.kcArr=res.data;
            })
            getTeacher().then(res=>{
                this.jsArr=res.data;
            })
            this.type=this.$route.query.type;
            this.bookInfo.courseProgramId = this.$route.query.courseProgramId
            this.searchForm.courseNo=this.$route.query.courseId;
            this.searchForm.languageName=this.$route.query.languageName;
            this.searchForm.semester=this.$route.query.semester;
            this.bookApproveInfo.id = this.$route.query.id
            if(this.type != 'add'){
                this.fetch();
            }
            this.bookInfo.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.bookInfo.semester=getSemester()

        },
        methods:{
            fetch(){
                
                if(this.$route.query.id){
                    bookInfo(this.$route.query.id).then(res=>{
                        if(res.data !=null){
                            this.bookInfo=res.data
                            this.year=this.bookInfo.semester.substr(0,4)
                            this.coverFileList=[];
                            if(res.data.coverFile!=''&&res.data.coverFile!=null){
                                this.coverFile=res.data.coverFile.split(";");
                                for(let i=0;i<this.coverFile.length;i++){
                                    this.coverFileList.push({
                                        uid: i,
                                        name: this.coverFile[i]+i,
                                        status: 'done',
                                        url: this.$store.state.axiosUrl+this.coverFile[i],
                                    })
                                }
                            }
                                                        
                            this.syllabusFileList=[];
                            if(res.data.files!=''&&res.data.files!=null){
                                this.files=res.data.files.split(";");
                                for(let i=0;i<this.files.length;i++){
                                    this.syllabusFileList.push({
                                        uid: i,
                                        name: this.files[i]+i,
                                        status: 'done',
                                        url: this.$store.state.axiosUrl+this.files[i],
                                    })
                                }
                            }   
                        }
                    })
                }else{
                    bookInfoCourse(this.searchForm).then(res=>{
                        
                        if(res.data !=null && res.data !=''){
                            this.bookInfo=res.data
                            this.year=this.bookInfo.semester.substr(0,4)
                            this.coverFileList=[];
                            if(res.data.coverFile!=''&&res.data.coverFile!=null){
                                this.coverFile=res.data.coverFile.split(";");
                                for(let i=0;i<this.coverFile.length;i++){
                                    this.coverFileList.push({
                                        uid: i,
                                        name: this.coverFile[i]+i,
                                        status: 'done',
                                        url: this.$store.state.axiosUrl+this.coverFile[i],
                                    })
                                }
                            }
                                                        
                            this.syllabusFileList=[];
                            if(res.data.files!=''&&res.data.files!=null){
                                this.files=res.data.files.split(";");
                                for(let i=0;i<this.files.length;i++){
                                    this.syllabusFileList.push({
                                        uid: i,
                                        name: this.files[i]+i,
                                        status: 'done',
                                        url: this.$store.state.axiosUrl+this.files[i],
                                    })
                                }
                            }   
                        }else{
                            this.$router.go(-1)
                            this.$notification['info']({
                                message: '提示',
                                description:'无相关教材信息！',
                            });
                        }
                    })
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.bookInfo.schoolYear=this.year+'-'+(this.year-0+1);
                this.bookInfo.semester='';
                this.yearShowOne = false;
            },
            handleOk(status) {
                this.bookApproveInfo.approvalStatus=status
                this.bookSub()
                this.$router.go(-1)
            },
            coverFileChange(file){
                if(typeof file.file.response!='undefined'){
                    var res=file.file.response;
                    this.$notification['success']({
                        message: '成功',
                        description:'文件上传成功'
                    });
                    this.coverFile.push(res.url)
                }else if(file.file.status=='removed'){
                    var num=this.coverFile.indexOf(file.file);
                    this.coverFile.splice(num, 1)
                }
                this.coverFileList=file.fileList;
                
                console.log('coverFile'+this.coverFile)
            },
            syllabusFileChange(file){
                if(typeof file.file.response!='undefined'){
                    var res=file.file.response;
                    this.$notification['success']({
                        message: '成功',
                        description:'文件上传成功'
                    });
                    this.files.push(res.url)
                }else if(file.file.status=='removed'){
                    var num=this.files.indexOf(file.file);
                    this.files.splice(num, 1)
                }
                this.syllabusFileList=file.fileList;
                console.log('files'+this.files)
            },
            bookSub(){
                if(this.coverFile.length > 0){
                    this.bookInfo.coverFile=this.coverFile.join(';')
                }
                if(this.files.length > 0){
                    this.bookInfo.files=this.files.join(';')
                } 
                if(this.type == 'add'){
                    this.bookInfo.approvalStatus='commit'
                    addBook(this.bookInfo).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'新增教材成功，请联系系主任审批！',
                                duration: 0,
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        this.fetch()
                    })
                }else if(this.type == 'edit'){
                    bookEdit(this.bookInfo).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'编辑教材成功！',
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        this.fetch()
                    })
                }else if(this.type == 'approve'){
                    bookApprove(this.bookApproveInfo).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description: this.bookApproveInfo.approvalStatus == 'approved' ? '教材审核成功！' :'教材驳回成功！',
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        this.fetch()
                    })
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            kcChange(value){
                for(let i=0;i<this.kcArr.length;i++){
                    if(this.kcArr[i].courseName==value){
                        this.info.courseCode=this.kcArr[i].courseCode
                    }
                }
            },
            teacherSelect(){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==this.info.teacherNo){
                        this.info.teacherName=this.jsArr[i].teacherName
                        this.info.orgName=this.jsArr[i].orgName
                        this.info.orgCode=this.jsArr[i].orgCode
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box-half{
        width: 49.5%;
    }
    .info-main .input-box-big{
        width: 66%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box p span{
        color: #ff0000;
        margin-right: 5px;
    }
    .info-main .input-box .input{
        width: calc(100% - 12rem);
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
        margin-right: 1rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .upload-box{
        margin-top: 2rem;
        width: 50%;
        height: 10%;
        display: flex;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled,.ant-calendar-picker >>> .ant-input[disabled]{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .upload-box >>> .ant-upload-list:after{
      content: ".";
      display: block;
      font-size: 0;
      height: 0;
      clear: both;
    }
    .upload-box >>> .ant-upload.ant-upload-disabled{
        display: none;
    }
    .reject-btn{
        background-color: #ffa500;
        border-color: #ffa500;
    }
    .upload-info-box{
        margin-bottom: 2rem;
        display: flex;
    }
    .book-list{
        margin-left: 10rem;
        width: 80%;
    }
</style>
